<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "SkupTemaBase"
};
</script>

<style scoped>

</style>
